import { createApi } from "@reduxjs/toolkit/query/react";

import { axiosBaseQuery } from "./api";

export const bannersApi = createApi({
  reducerPath: "bannersApi",
  baseQuery: axiosBaseQuery,
  tagTypes: ["banners"],
  endpoints: (builder) => ({
    getBanners: builder.query({
      query: () => ({
        url: "banners",
      }),
      transformResponse: (response) => {
        return response.data.banners;
      },
      providesTags: ["banners"],
    }),
  }),
});
export const { useGetBannersQuery } = bannersApi;
